import {useQuery} from "@tanstack/react-query";
import {
    readDashboardSetting, readRevenueByHandlerByMonth, readRevenueByHandlerByYear,
    readRevenueByItem, readRevenueByTeamByMonth,
    readRevenueByTeamByQuarter, readRevenueByTeamByYear, readRevenueByUserByLastYear, readRevenueByUserByMonth
} from "../../../../../api/main/DashboardApi";
import {DashboardSettingSearchParamType} from "../interface";

export const useReadRevenueByUserByLastYear = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByUserByLastYear"],
        queryFn: async () => await readRevenueByUserByLastYear(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
